const C = require("../constants");

const ticketEditModal = (data) => {
    return {
        type: C.TICKET_EDIT_DIALOG,
        data
    }
};

export {ticketEditModal};


// WEBPACK FOOTER //
// ./src/actions/TicketEditDialog.js